import {Module} from '@fantasmagames/slot/src/common/Module';
import {RestoreScreenEvents} from '@fantasmagames/slot/src/modules/restoreScreen/RestoreScreenEvents';
import {InfoPopupEvents} from '@fantasmagames/slot/src/modules/popupmenus/info/InfoPopupEvents';
import {InfoPopupTypes} from '@fantasmagames/slot/src/modules/popupmenus/info/InfoPopupTypes';

/**
 * module handles restore window closed event (I know it's weird)
 */
export class RestoreScreenModule extends Module<null> {
	protected enterFirstState(): void {
	}

	protected setupStates(): void {
	}

	protected setupViews(): void {
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(InfoPopupEvents.INFO_POPUP_CLOSED, this.onInfoPopupClosed);
		this.on(InfoPopupEvents.RESTORE_POPUP_OPENED, this.onRestorePopupOpened);
	}

	protected onRestorePopupOpened(): void {
		this.eventManager.emit(RestoreScreenEvents.RESTORE_WINDOW_OPENED);
	}

	protected onInfoPopupClosed(eventId: string, eventType: InfoPopupTypes): void {
		if (eventType === InfoPopupTypes.RESTORE) {
			this.onRestoreScreenClicked();
		}
	}

	protected onRestoreScreenClicked(): void {
		this.eventManager.emit(RestoreScreenEvents.RESTORE_WINDOW_CLOSED);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/restoreScreen/RestoreScreenModule.ts